export default "__VITE_ASSET__9gZuQxPC__"